import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface MemoryViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class MemoryViewPage extends Component<MemoryViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.memory.view }}
                pages={{
                    entity: InferenceEntities.memory(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}